import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 bg-gradient-to-b from-[#150B24] to-[#020202] relative" data-id="element-174">
      <div className="container mx-auto px-4" data-id="element-175">
        <div className="text-center mb-12" data-id="element-176">
          <h2 className="text-3xl md:text-6xl font-bold mb-4" data-id="element-177">
            Elegí tu plan y empezá a escalar hoy
          </h2>
          <p className="text-purple-200/80 text-lg md:text-xl" data-id="element-178">
            Un solo pago. Acceso de por vida. Sin suscripciones.
          </p>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-179">
          {/* Value Stack */}
          <div className="bg-[#0F0A16] border border-white/10 rounded-t-3xl p-6 md:p-8 pb-12 relative z-0 translate-y-4" data-id="element-180">
            <h3 className="text-center text-gray-400 font-medium mb-6 uppercase tracking-widest text-sm" data-id="element-181">
              Todo lo que incluye:
            </h3>
            <ul className="space-y-3 text-sm md:text-base text-gray-300 mb-8" data-id="element-182">
              {[{
              name: 'Generador de Volumen Industrial',
              price: '$99.990'
            }, {
              name: 'Angle-Splitter Automático',
              price: '$49.990'
            }, {
              name: 'Base de Conocimiento',
              price: '$29.990'
            }, {
              name: 'Exportación a Meta Ads',
              price: '$19.990'
            }, {
              name: 'BONUS: Plantillas de Copy',
              price: '$29.990'
            }, {
              name: 'BONUS: Guía de Ángulos',
              price: '$19.990'
            }, {
              name: 'BONUS: Comunidad Privada',
              price: '$14.990'
            }, {
              name: 'BONUS: Updates de por Vida',
              price: 'Incalculable'
            }].map((item, i) => <li key={i} className="flex justify-between items-center border-b border-white/5 pb-2 last:border-0" data-id="element-183">
                  <span className="flex items-center gap-2" data-id="element-184">
                    <Check className="w-4 h-4 text-green-500" data-id="element-185" />
                    {item.name}
                  </span>
                  <span className="text-gray-500 font-mono" data-id="element-186">{item.price}</span>
                </li>)}
            </ul>
            <div className="text-center pt-4 border-t border-white/10" data-id="element-187">
              <p className="text-gray-500 text-sm mb-1" data-id="element-188">Valor Total Real</p>
              <p className="text-2xl font-bold text-gray-400 line-through decoration-red-500" data-id="element-189">
                $264.840
              </p>
            </div>
          </div>

          {/* Main Card */}
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="bg-[#050505] border-2 border-purple-500 rounded-3xl p-6 md:p-12 relative z-10 shadow-[0_0_60px_rgba(139,92,246,0.2)] text-center" data-id="element-190">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 py-2 rounded-full font-bold text-sm uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-191">
              Oferta de Lanzamiento
            </div>

            <div className="mb-6 md:mb-8 mt-4" data-id="element-192">
              <div className="inline-block bg-green-500/10 text-green-400 border border-green-500/20 px-3 py-1 rounded-lg text-sm font-bold mb-4" data-id="element-193">
                Ahorrás $187.140
              </div>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-194">
                <span className="text-5xl md:text-7xl font-bold text-white font-sora tracking-tight" data-id="element-195">
                  $77.700
                </span>
                <span className="text-xl text-gray-500 font-medium self-end mb-2" data-id="element-196">
                  ARS
                </span>
              </div>
              <p className="text-gray-400 font-medium" data-id="element-197">
                Pago Único - Acceso de por Vida
              </p>
            </div>

            {/* Bullets */}
            <div className="text-left max-w-xs mx-auto space-y-2 mb-8 text-sm md:text-base text-gray-300" data-id="element-198">
              <p className="flex items-center gap-2" data-id="element-199">
                ✅ Acceso inmediato a la plataforma
              </p>
              <p className="flex items-center gap-2" data-id="element-200">
                ✅ Todos los bonus incluidos
              </p>
              <p className="flex items-center gap-2" data-id="element-201">
                ✅ Updates gratis de por vida
              </p>
            </div>

            <a href="https://100creativos.techain.io/checkouts/cn/hWN8fJmHHZBvctC0US4Ntuew/es-ar?_r=AQAB5l89NPNp71bW8YirafWaOUlctjjZkh00uZ7PGpFpUGI&preview_theme_id=150846177448" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-bold text-lg md:text-xl py-5 md:py-6 px-6 md:px-8 rounded-xl shadow-[0_10px_40px_rgba(139,92,246,0.4)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-glow mb-6 text-center" data-id="element-202">
              ACCEDER A LA APP →
            </a>

            <div className="flex flex-col md:flex-row justify-center items-center gap-3 text-[10px] md:text-xs text-gray-500 uppercase font-bold tracking-wider" data-id="element-203">
              <span data-id="element-204">🔒 Pago seguro</span>
              <span className="hidden md:inline" data-id="element-205">•</span>
              <span data-id="element-206">⚡ Acceso inmediato</span>
              <span className="hidden md:inline" data-id="element-207">•</span>
              <span data-id="element-208">🛡️ Garantía 72hs</span>
            </div>

            <div className="mt-6 pt-6 border-t border-white/10" data-id="element-209">
              <p className="text-yellow-500/80 text-sm flex items-center justify-center gap-2" data-id="element-210">
                <span data-id="element-211">⚠️</span> Esta oferta de lanzamiento es por tiempo
                limitado
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}